import { render } from "./DAOEvents.vue?vue&type=template&id=fe8897da&scoped=true"
import script from "./DAOEvents.vue?vue&type=script&lang=js"
export * from "./DAOEvents.vue?vue&type=script&lang=js"

import "./DAOEvents.vue?vue&type=style&index=0&id=fe8897da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8897da"]])

export default __exports__